




















import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
@Component({
    components: {
      
    },
})
export default class imageDialog extends Vue {
    public $refs: {
    };
    @Prop({
        default:''
    })
    ImgUrl:Boolean;
    
    
    show = false;

    created() {
    }
    mounted() { 
    }

    opens(){
        this.show = true
    }
    onClose(){
        this.show = false;
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/imageDialog.vue